import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import VehiculosHabilitacionDashboard from '../../components/administracion/EnableVehiclesDashboard';
//import { useParams } from "react-router-dom";

const VehiculosHabilitacionPage = () => {

    return (
        <Box sx={{ p: 2 }}>
            <VehiculosHabilitacionDashboard
                //windows={empleadosHabilitacion}
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de vehiculos habilitados:', newOrder);
                }}
            />
        </Box>
    );
};

export default VehiculosHabilitacionPage;